import React from 'react';

export const PersonIcon = ({
  color = 'black',
  size = '20',
}: {
  color?: string;
  size?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
    >
      <defs>
        <style>{`
          .cls-1 {
            fill: ${color};
          }
        `}</style>
      </defs>
      <g id="noun_User_70744" transform="translate(-5.385 -4.604)">
        <path
          id="Union_7"
          data-name="Union 7"
          className="cls-1"
          d="M19350.16,6069.008a4.7,4.7,0,0,0-3.186-4.415,3.909,3.909,0,0,1-3.316,0,4.585,4.585,0,0,0-3.045,4.415.613.613,0,0,1-1.227,0,5.81,5.81,0,0,1,3.135-5.236,3.6,3.6,0,0,1-1-2.491,3.8,3.8,0,0,1,7.59,0,3.627,3.627,0,0,1-1,2.491,5.9,5.9,0,0,1,3.275,5.236.613.613,0,0,1-1.227,0Zm-7.412-7.727a2.567,2.567,0,1,0,2.57-2.485A2.534,2.534,0,0,0,19342.748,6061.281Z"
          transform="translate(-19330 -6049.001)"
        />
      </g>
    </svg>
  );
};
